module.exports = __webpack_public_path__ + "img/img23.3dfaf525.svg";